function reset_password(id) {
    var $ = jQuery.noConflict();
    confirm('Weet u zeker dat u het wachtwoord van deze gebruiker wilt resetten?', function() {
        $('body').isLoading('dark');

        $.ajax({
            url: '/user/reset_password',
            data: {id: id},
            type: "POST",
            success: function(data) {
                $('body').doneLoading();
                squde_flash("Wachtwoord opnieuw ingesteld en per email verzonden");
                reload_location_if_needed();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });

    });
}

function login_as(email) {
    console.log({email});
    window.location.href = '/loginAs/' + email;
    return false;
}